'use client';

import React from 'react';
import CosaServiceLayout from '@/components/CosaServiceLayout';

const serviceData = {
  slug: 'soins-preventifs',
  icon: 'fa-solid fa-shield-heart',
  badge: 'Soins Préventifs',
  title: 'Soins Préventifs',
  subtitle: 'Prévention et bien-être pour une meilleure santé',
  heroImage: '/assets/images/service_preventive_care.png',
  heroAlt: 'Professionnel de santé africain en séance de prévention et bien-être à COSA',
  accentColor: '#0e5932',
  description: `Les soins préventifs de COSA incluent diététique, kinésithérapie, vaccinations, programmes de prévention et conseil médical. Notre approche holistique vise à maintenir votre santé et prévenir les maladies.`,
  features: [
    { icon: 'fa-solid fa-apple', title: 'Diététique', description: 'Consultations nutritionnelles et plans alimentaires personnalisés.' },
    { icon: 'fa-solid fa-person-hiking', title: 'Kinésithérapie', description: 'Rééducation physique et thérapie pour récupération et bien-être.' },
    { icon: 'fa-solid fa-syringe', title: 'Vaccinations', description: 'Programme complet de vaccinations selon les recommandations sanitaires.' },
    { icon: 'fa-solid fa-heart-pulse', title: 'Programmes de Prévention', description: 'Programmes de prévention des maladies chroniques et du bien-être.' },
    { icon: 'fa-solid fa-brain', title: 'Conseil Médical', description: 'Conseils médicaux personnalisés pour un mode de vie sain.' },
    { icon: 'fa-solid fa-dumbbell', title: 'Bien-être & Confort', description: 'Services de bien-être incluant relaxation et gestion du stress.' },
  ],
  process: [
    { step: '01', title: 'Évaluation Initiale', description: 'Évaluation complète de votre état de santé et objectifs.' },
    { step: '02', title: 'Plan Personnalisé', description: 'Création d\'un plan de prévention adapté à vos besoins.' },
    { step: '03', title: 'Suivi Régulier', description: 'Suivi régulier et ajustements du plan selon votre progression.' },
    { step: '04', title: 'Résultats Durables', description: 'Atteinte d\'objectifs de santé et bien-être durables.' },
  ],
  stats: [
    { value: '300+', label: 'patients suivis' },
    { value: '95%', label: 'taux de satisfaction' },
    { value: '6', label: 'types de services' },
    { value: '70+', label: 'ans d\'expertise' },
  ],
};

export default function SoinsPreventifsPage() {
  return <CosaServiceLayout service={serviceData} />;
}
